(() => {
  if (window.KandroStore) return;

  const root = document.documentElement;
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let lastTrigger = null;
  let activeOverlay = null;

  const visibleFocusable = (container) => Array.from(container.querySelectorAll(focusableSelector)).filter((element) => {
    return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
  });

  const closeSubmenus = (except = null, scope = document) => {
    scope.querySelectorAll('[data-kandro-submenu-toggle]').forEach((toggle) => {
      if (toggle === except) return;
      toggle.setAttribute('aria-expanded', 'false');
      const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (submenu) submenu.hidden = true;
    });
  };

  const closeOverlays = (restoreFocus = true) => {
    root.classList.remove('kandro-menu-open', 'kandro-search-open');
    document.querySelectorAll('[data-kandro-menu-toggle], [data-kandro-search-toggle]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-kandro-menu], [data-kandro-search]').forEach((overlay) => {
      overlay.setAttribute('aria-hidden', 'true');
    });
    closeSubmenus();
    activeOverlay = null;

    const trigger = lastTrigger;
    lastTrigger = null;
    if (restoreFocus && trigger && document.contains(trigger)) trigger.focus();
  };

  const openOverlay = (type, trigger) => {
    closeOverlays(false);
    lastTrigger = trigger;
    const id = trigger.getAttribute('aria-controls');
    const overlay = id ? document.getElementById(id) : document.querySelector(type === 'menu' ? '[data-kandro-menu]' : '[data-kandro-search]');
    if (!overlay) return;

    activeOverlay = overlay;
    root.classList.add(type === 'menu' ? 'kandro-menu-open' : 'kandro-search-open');
    trigger.setAttribute('aria-expanded', 'true');
    overlay.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(() => {
      const first = visibleFocusable(overlay)[0];
      if (first) first.focus();
    });
  };

  const toggleSubmenu = (toggle) => {
    const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!submenu) return;
    const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
    closeSubmenus(toggle, toggle.closest('[data-kandro-menu]') || document);
    toggle.setAttribute('aria-expanded', String(willOpen));
    submenu.hidden = !willOpen;
  };

  const trapFocus = (event) => {
    if (event.key !== 'Tab' || !activeOverlay) return;
    const elements = visibleFocusable(activeOverlay);
    if (!elements.length) return;
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const initCarousel = (carousel) => {
    if (carousel.dataset.kandroReady === 'true') return;
    carousel.dataset.kandroReady = 'true';

    const track = carousel.querySelector('[data-kandro-track]');
    const previous = carousel.querySelector('[data-kandro-prev]');
    const next = carousel.querySelector('[data-kandro-next]');
    if (!track || !previous || !next) return;

    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2 || max <= 2;
    };

    const move = (direction) => {
      track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.82, 260), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-kandro-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-kandro-submenu-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (submenu) submenu.hidden = true;
    });
    scope.querySelectorAll('[data-kandro-menu], [data-kandro-search]').forEach((overlay) => {
      overlay.setAttribute('aria-hidden', 'true');
    });
  };

  document.addEventListener('click', (event) => {
    const menuToggle = event.target.closest('[data-kandro-menu-toggle]');
    const searchToggle = event.target.closest('[data-kandro-search-toggle]');
    const submenuToggle = event.target.closest('[data-kandro-submenu-toggle]');
    const close = event.target.closest('[data-kandro-close]');
    const drawerLink = event.target.closest('[data-kandro-menu] a[href]');

    if (menuToggle) {
      openOverlay('menu', menuToggle);
      return;
    }
    if (searchToggle) {
      openOverlay('search', searchToggle);
      return;
    }
    if (submenuToggle) {
      toggleSubmenu(submenuToggle);
      return;
    }
    if (drawerLink) {
      closeOverlays(false);
      return;
    }
    if (close || event.target.matches('[data-kandro-menu], [data-kandro-search]')) closeOverlays();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeOverlay) {
      event.preventDefault();
      closeOverlays();
      return;
    }
    trapFocus(event);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.KandroStore = { init, closeOverlays };
})();
